import React from 'react';
import { shallow } from 'enzyme';
import Notifier, { createQueuedNotifier } from './index';

it('props contain emitter', () => {
  const { QueuedNotifier } = createQueuedNotifier();
  Notifier.addMessage('Test message');
  const wrapper = shallow(<QueuedNotifier />);
  expect(wrapper.props().emitter.subscribe).toBeDefined();
  expect(wrapper.props().emitter.emit).toBeDefined();
});
